import { apiService } from "./apiService";
import { endpoints } from "../config/endpoints";

export default {
  getSuggestedLocations(payload) {
    return apiService.get(`${endpoints.locations.suggested}${payload}`);
  },

  getSearchLocations() {
    return apiService.get(endpoints.searchLocations);
  },

  rejectSuggestedLocation(suggestedLocation) {
    return apiService.post(endpoints.locations.rejected, suggestedLocation);
  }
};
